export const fmt = d => new Date(d).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })
/* Lead timestamp / timeline */
export default function LeadTimeline({ items }) {
  return (<div className="card"><div className="card-body"><h6 className="mb-3">Timeline</h6>
    {items.length ? <div className="timeline">{items.map((e, i) => <div className="ev" key={i}><small className="text-muted">{fmt(e.at)}</small><div>{e.event}</div></div>)}</div>
      : <div className="text-muted">No activity yet.</div>}</div></div>)
}
